export const state = () => ({
  swd: false,
  gwp: false,
  items: [],
  note: '',
  savings: 0,
  urgency: {},
  subtotal: 0,
  defaultPrice: 0,
  global: {},
  swd_tags: [],
  promoReady: false,
  original_subtotal: 0,
  tiered_eligible_subtotal: 0,
  terms: false,
  loaded: false,
  quantity_policy: 0,
  free_ship_thresh: 0,
  gift_note: false,
  mode: 'production',
  cart_preorder: 'false',
  tieredDiscount: {
    enabled: false,
    tags: '',
    title: '',
    descriptions: {
      upper: '',
      lower: '',
    },
    tier1: {},
    tier2: {},
    tier3: {},
  },
  upsell: {
    items: [],
    title: null,
    loaded: false,
    overwritten: false,
    allow_overwrite: false,
    decisionId: null,
    variationId: null,
  },
});
